import { Card } from '@optools/components/ui/card';
import { Skeleton } from '@optools/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { EsniRule } from '@optools/services/operator-gateway/types/generated/graphql';
import { orderBy } from 'es-toolkit';

import { ESNIRuleStatusBadge } from '../esni-rule-status-badge';
import { ESNIRuleTypeBadge } from '../esni-rule-type-badge';
import { EmptyState } from './empty-state';

type Rule = Pick<EsniRule, 'id' | 'name' | 'type' | 'status' | 'priority'>;
export interface RulesCardProps {
  loading: boolean;
  rules: Rule[];
}

export function RulesCard({ loading, rules }: RulesCardProps) {
  return (
    <Card className="flex min-h-40 flex-1 flex-col gap-4 p-4" data-testid="rules-card">
      <h2 className="text-xl font-semibold">Rules</h2>
      {loading ? (
        <Skeleton className="min-h-80 flex-1" data-testid="rules-skeleton" />
      ) : rules?.length > 0 ? (
        <Table className="-ml-2 animate-fade-in">
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-center">Priority</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orderBy(rules, ['priority', 'name'], ['asc']).map(
              ({ id, name, priority, status, type }) => (
                <TableRow key={id}>
                  <TableCell>{name}</TableCell>
                  <TableCell>
                    <ESNIRuleTypeBadge type={type} />
                  </TableCell>
                  <TableCell>
                    <ESNIRuleStatusBadge status={status} />
                  </TableCell>
                  <TableCell className="text-center">{priority}</TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      ) : (
        <EmptyState message="No rules were matched this media" />
      )}
    </Card>
  );
}
